import { writable } from 'svelte/store';

type ABTestVersion = 'A' | 'B';

// ab test store
export const abTestVersion = writable<ABTestVersion>();

export function isABTestVersion(value: string | undefined): value is ABTestVersion {
  return value === 'A' || value === 'B';
}
